import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetErfinaInvoiceStatusResponseDto } from "../../dtos/get-erfina-invoice-status-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetErfinaInvoiceStatusQueryParams = {
  queryParams: { publicClaimId: string };
  options?: Omit<
    UseQueryOptions<GetErfinaInvoiceStatusResponseDto>,
    "queryKey"
  >;
};

export const useGetErfinaInvoiceStatusQuery = ({
  queryParams,
  options
}: UseGetErfinaInvoiceStatusQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getErfinaInvoiceStatus(queryParams.publicClaimId)
      .queryKey,
    queryFn: async () =>
      await OrderService.getErfinaInvoiceStatus({ payload: queryParams }),
    ...options
  });
};
